export default __webpack_public_path__ + "static/media/06.3cf563b1.jpg";